import { Banner, Container, Footer } from 'darrius';

import { Header } from '../../components/atoms';
import { Faq } from '../../components/molecules/Faq/Faq';

import {
  homePage,
  requestService,
  aboutPage,
  requestPage,
  formData,
} from '../../locales/pt-BR';

import {
  HeaderLead,
  HomeCounting,
  HeadContent,
  FormLead,
  AboutCompany,
  Testimonials,
  RequestCallToAction,
} from '../../components';

import styles from './ProspectTemplateCategory.module.scss';

interface IProspectTemplateProps {
  dynamicData: {
    metaDescription: string;
    titleHeader: string;
    slug: string;
    friendlyName: string;
    name: string;
    titleHeaderContent?: string;
    faq: Array<{
      question: string;
      answer: string;
    }>;
    info: {
      headerProImage: {
        original: string;
      };
    };
  };
  title: string;
  text: string;
  staticContent: {
    footerContent: any;
    testimonialsContent: any;
  };
}

export default function ProspectTemplateCategory(
  props: IProspectTemplateProps
) {
  const {
    dynamicData,
    staticContent,
    text = 'Preencha os campos abaixo',
    title,
  } = props;

  const {
    metaDescription,
    slug,
    friendlyName,
    titleHeaderContent,
    name,
    faq,
    info,
  } = dynamicData;

  const { footerContent, testimonialsContent } = staticContent;

  return (
    <>
      <HeadContent
        metaTitle={`${homePage.title} ${titleHeaderContent}`}
        slug={slug}
        metaDescription={metaDescription}
        type="prospect:show"
      />

      <Header.Simple />

      <main className={styles.prospect_template__main}>
        <HeaderLead
          homeDescription={homePage.description}
          titleHeaderContent={`${homePage.title} ${name}`}
          friendlyName={friendlyName}
          info={info}
          text={text}
          title={title}
          formContent={formData}
        />

        <AboutCompany content={aboutPage} />

        <Testimonials testimonialsContent={testimonialsContent} />

        <Container as="section">
          <Banner
            className={`${styles['second-form']} fixed form-lead`}
            size="2"
            text={text}
            title={`${homePage.title} ${titleHeaderContent}`}
          >
            <FormLead
              direction="horizontal"
              order="second_form"
              content={formData}
              buttonText="Cadastre-se gratuitamente"
            />
          </Banner>
        </Container>

        <HomeCounting />

        <RequestCallToAction
          content={requestPage}
          title={`${requestService.title} ${titleHeaderContent}`}
          slug={slug}
        />

        {faq && <Faq questions={faq} title="Perguntas frequentes" />}
      </main>

      <Footer data={footerContent} />
    </>
  );
}
